module.exports = __webpack_public_path__ + "static/media/bells.d227b7c9.svg";